import { render } from "./Iframe.vue?vue&type=template&id=135885c0&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./Iframe.vue?vue&type=style&index=1&id=135885c0&lang=css"
import "./Iframe.vue?vue&type=style&index=2&id=135885c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135885c0"]])

export default __exports__